import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ExportClipboardParameter } from './export-clipboard-parameter';
import { Jwt } from '@colimo/colimo-ui-library/lib/auth/authentication-rest/jwt';
import { ClipboardLinkResponse } from './clipboard-link-response';

/**
 * Service responsible for providing access to export to clipboard functionality.
 */
@Injectable({
  providedIn: 'root',
})
export class ExportToClipboardService {
  private endpointMeanValues: string;
  private endpointMeasurements: string;
  private endpointLinkToMeasurements: string;
  private endpointLinkToMeanValues: string;

  constructor(private http: HttpClient,  private datePipe: DatePipe) {
    const host = environment.apiBasePath + environment.apiUserPath;
    this.endpointMeanValues = `${host}/${environment.exportToClipboard.exportFMCCTBClipboardMeanValues}`;
    this.endpointMeasurements = `${host}/${environment.exportToClipboard.exportFMCCTBClipboardMeasurements}`;
    this.endpointLinkToMeasurements = `${host}/${environment.linkToClipboard.linkToFMCCTBClipboardMeasurements}`;
    this.endpointLinkToMeanValues = `${host}/${environment.linkToClipboard.linkToFMCCTBClipboardMeanValues}`;
  }

public getExportFMCCTBClipboardMeanValues(
  exportClipboardParameter: ExportClipboardParameter
): Observable<Blob> {

  let params = new HttpParams()
    .set('batchId', exportClipboardParameter.batchId.toString())
    .set('line', exportClipboardParameter.line)
    .set('models', exportClipboardParameter.models)
    .set('bodyComponents', exportClipboardParameter.bodyComponents)
    .set('bumperComponents', exportClipboardParameter.bumperComponents);

  if (exportClipboardParameter.startDate) {
    params = params.set(
      'startDate',
      this.datePipe.transform(exportClipboardParameter.startDate, 'yyyy-MM-dd')!
    );
  }

  if (exportClipboardParameter.endDate) {
    params = params.set(
      'endDate',
      this.datePipe.transform(exportClipboardParameter.endDate, 'yyyy-MM-dd')!
    );
  }

  return this.http.get(this.endpointMeanValues, {
    params,
    responseType: 'arraybuffer'
  }).pipe(
    map((response: any) => this.createBlobByAny(response)),
    catchError((error: HttpErrorResponse) =>
      throwError(() => error || error.error || 'Server error')
    )
  );
}


  public getExportFMCCTBClipboardMeasurements(exportClipboardParameter: ExportClipboardParameter): Observable<Blob> {
   let params = new HttpParams()
    .set('batchId', exportClipboardParameter.batchId.toString())
    .set('line', exportClipboardParameter.line)
    .set('models', exportClipboardParameter.models)
    .set('bodyComponents', exportClipboardParameter.bodyComponents)
    .set('bumperComponents', exportClipboardParameter.bumperComponents);

 if (exportClipboardParameter.startDate) {
    params = params.set(
      'startDate',
      this.datePipe.transform(exportClipboardParameter.startDate, 'yyyy-MM-dd')!
    );
  }

  if (exportClipboardParameter.endDate) {
    params = params.set(
      'endDate',
      this.datePipe.transform(exportClipboardParameter.endDate, 'yyyy-MM-dd')!
    );
  }
return this.http.get(this.endpointMeasurements, {
    params,
    responseType: 'arraybuffer'
  }).pipe(
    map((response: any) => this.createBlobByAny(response)),
    catchError((error: HttpErrorResponse) =>
      throwError(() => error || error.error || 'Server error')
    )
  );
}

  public linkToFMCCTBClipboardMeasurements(exportClipboardParameter: ExportClipboardParameter, jwt: Jwt): Observable<ClipboardLinkResponse> {
  let params = new HttpParams()
    .set('batchId', exportClipboardParameter.batchId.toString())
    .set('line', exportClipboardParameter.line)
    .set('models', exportClipboardParameter.models)
    .set('bodyComponents', exportClipboardParameter.bodyComponents)
    .set('bumperComponents', exportClipboardParameter.bumperComponents);

  if (exportClipboardParameter.startDate) {
    params = params.set(
      'startDate',
      this.datePipe.transform(exportClipboardParameter.startDate, 'yyyy-MM-dd')!
    );
  }

  if (exportClipboardParameter.endDate) {
    params = params.set(
      'endDate',
      this.datePipe.transform(exportClipboardParameter.endDate, 'yyyy-MM-dd')!
    );
  }

return this.http.post<ClipboardLinkResponse>(
  this.endpointLinkToMeasurements,
  jwt,
  { params }
);
}

  public linkToFMCCTBClipboardMeanValues(exportClipboardParameter: ExportClipboardParameter, jwt: Jwt): Observable<ClipboardLinkResponse> {


  let params = new HttpParams()
    .set('batchId', exportClipboardParameter.batchId.toString())
    .set('line', exportClipboardParameter.line)
    .set('models', exportClipboardParameter.models)
    .set('bodyComponents', exportClipboardParameter.bodyComponents)
    .set('bumperComponents', exportClipboardParameter.bumperComponents);

  if (exportClipboardParameter.startDate) {
    params = params.set(
      'startDate',
      this.datePipe.transform(exportClipboardParameter.startDate, 'yyyy-MM-dd')!
    );
  }

  if (exportClipboardParameter.endDate) {
    params = params.set(
      'endDate',
      this.datePipe.transform(exportClipboardParameter.endDate, 'yyyy-MM-dd')!
    );
  }

  return this.http.post<ClipboardLinkResponse>(this.endpointLinkToMeanValues, jwt, { params });
}


  private createBlobByAny(response: any): Blob {
    return new Blob([response]);
  }
}
